export default "__VITE_ASSET__BScxx5Ex__"